export default {
  getLeaseRateChangeEventPaymentIds: state => state.leaseRateChangeEventPaymentIds || [],
  notChangesEventPaymentIds: state => state.notChangesEventPaymentIds || [],
  getContractAssetComponents: state => state.contractAssetComponents || []
};
